const tabs = [
  { label: "Create Invoice", path: "/iil-invoice" },
  { label: "Attendance", path: "/iil-attendance" },
  { label: "Advances", path: "/iil-advances" }
];

export default function IILSubnav() {
  const currentPath = window.location.pathname;
  const navigate = (path) => {
    window.history.pushState({}, "", path);
    window.dispatchEvent(new PopStateEvent("popstate"));
  };

  return <nav className="iil-subnav" aria-label="IIL workflow">
    <span className="iil-subnav-label">IIL</span>
    {tabs.map((tab) => <button
      key={tab.path}
      type="button"
      className={`iil-subnav-item ${currentPath === tab.path ? "active" : ""}`}
      onClick={() => navigate(tab.path)}
    >{tab.label}</button>)}
  </nav>;
}
